module.exports = __webpack_public_path__ + "static/media/objects_25.46d9857a.svg";